<template>
  <onboarding-step>
    <template #heading>
      Select your priority level for each job
    </template>
    <template #content>
      <div>
        <l-job-priorities-input
          v-model="user.report"
          class="space-y-3 max-w-lg"
          :hide="Priority.NO"
          :min="Priority.LOW"
        />
      </div>
    </template>
    <template #footer>
      <podcast-promo class="lg:hidden"/>
    </template>
    <template #subcontent>
      <div class="flex flex-col gap-10">
        <img src="/images/illustration-sitting-4.svg" class="h-auto mx-auto">
        <podcast-promo/>
      </div>
    </template>
  </onboarding-step>
</template>

<script setup>
import LJobPrioritiesInput from "@/components/inputs/LJobPrioritiesInput.vue"
import OnboardingStep from "@/components/onboardings/OnboardingStep.vue"
import PodcastPromo from "@/components/PodcastPromo.vue"
import { Priority } from "@/models/Priority"

const user = defineModel({ type: Object, required: true })
</script>
